<template>
  <div class='issue-priority-table-cell'>
    <img class='issue-priority-table-cell__image' :src='getPriority'>
  </div>
</template>

<script>

import lowest from '@/assets/icons/priority/lowest.svg';
import low from '@/assets/icons/priority/low.svg';
import medium from '@/assets/icons/priority/medium.svg';
import high from '@/assets/icons/priority/high.svg';
import highest from '@/assets/icons/priority/highest.svg';

export default {
  name: 'IssuePriorityTableCell',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    isTranslation: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getPriority() {
      const priority = Number(this.item.priority);
      if (priority <= 40) {
        return lowest;
      }
      if (priority > 40 && priority <= 58) {
        return low;
      }
      if (priority > 58 && priority <= 99) {
        return medium;
      }
      if (priority > 99 && priority <= 199) {
        return high;
      }
      return highest;
    },
  },
};
</script>

<style lang="scss" scoped>
.issue-priority-table-cell{
  margin-top: 5px;
  margin-left: 2px;
  width: 60px;
  justify-content: center;
  display: flex;
  &__image{
    width: 20px;
  }
}
</style>
